import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { KeycloakService } from 'keycloak-angular';
import { Elemento } from 'src/app/shared/models/elemento.model';
import { ElementoFiltro } from 'src/app/shared/models/elementoFiltro.model';
import { ElementService } from 'src/app/shared/services/element.service';
import { SuscripcionService } from 'src/app/shared/services/suscripcion.service';
import { environment } from 'src/environments/environment';
import {
  CommunityDataAbstractService,
  communityDataToken,
  DataIniciativasType,
} from '../../../community-data';
import { CommunityPanelService } from '../../../community-panel.service';

@Component({
  selector: 'app-iniciativas',
  templateUrl: './iniciativas.component.html',
  styleUrls: ['./iniciativas.component.scss'],
})
export class CommunityPanelIniciativasComponent {
  img_base = environment.img_base;
  pageIndex = 0;
  desplazamiento = 0;
  limite = 1000;
  totalItems = 0;
  elementos$: Elemento[] = [];
  communityService = inject<CommunityPanelService>(communityDataToken);

  public filtroUI = new FormGroup({
    nombre: new FormControl(),
    ordenPor: new FormControl('nombre'),
    ordenDireccion: new FormControl('asc'),
  });

  infoIniciativas = this.communityService.getInfo(
    'iniciativas',
  ) as DataIniciativasType;

  ngOnInit() {
    this.filtrar(false);
  }

  public async filtrar(cargarMas: boolean): Promise<void> {
    if (!cargarMas) {
      this.pageIndex = 0;
      this.desplazamiento = 0;
    }

    var filtroProyectos: ElementoFiltro = new ElementoFiltro();

    Object.keys(this.filtroUI.value).forEach(key => {
      if (key.includes('nombre')) {
        (filtroProyectos as any)[key] = (this.filtroUI.value as any)[key];
      }
    });

    const data = await this.communityService.getIniciativas(
      this.limite,
      this.pageIndex,
      filtroProyectos,
    );

    const normalize = (str: string): string => {
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    };

    const ordenPor = this.filtroUI.get('ordenPor')?.value;
    const ordenDireccion = this.filtroUI.get('ordenDireccion')?.value;

    if (ordenPor === 'id') {
      this.elementos$ = data.elementos.sort((a, b) =>
        ordenDireccion === 'asc' ? a.id - b.id : b.id - a.id,
      );
    } else if (ordenPor === 'nombre') {
      this.elementos$ = data.elementos.sort((a, b) =>
        ordenDireccion === 'asc'
          ? normalize(a.nombre).localeCompare(normalize(b.nombre))
          : normalize(b.nombre).localeCompare(normalize(a.nombre)),
      );
    }

    this.elementos$ = this.elementos$.filter(
      (value, index, self) => index === self.findIndex(t => t.id === value.id),
    );

    this.pageIndex++;
  }
}
